interface ImageType {
    src?: string;
    alt?: string;
}

interface Logo {
    src: string;
    alt: string;
}

export interface PaidCompany {
    companyName: string;
    companyId: number;
    id: number;
    logo: Logo;
    companyUrl: string;
    isSponsor?: boolean;
}

export interface UserCommunityData {
    id?: number;
    connectionCount?: number;
    followerCount?: number;
    isVip?: number;
}
interface Image {
    src: string;
    alt?: string;
}

export interface Author {
    userId: number;
    username: string;
    hash: string;
    active: boolean;
    authorHash: string;
    image: Image;
    authorImage: Image;
    authorName: string;
    userCommunityData?: UserCommunityData;
    connectWithMeText: string;
    credential: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface Article {
    contentModifiedDate: any;
    title: string;
    hash: string;
    contentImage: ImageType;
    createdAt: string;
    publishedAt?: string;
    isSponsor: boolean;
    showSponsoredBy: boolean;
    modifiedAt: string;
    description: string;
    active: boolean;
    authorHash: string;
    metaTitle: string;
    metaDescription: string;
    canonicalUrl: string;
    paidCompany: PaidCompany[];
    author: Author;
    regwall: {
        delaySeconds: number;
        forceLogin: boolean;
        position: string;
        allowClosing: boolean;
        signupCreative: {
            headerText: string;
            bodyText: string;
            buttonText: string;
            overlayColor: string;
            image: Image;
        };
    };
}

export interface LayoutProps {
    article: Article;
    hash: string;
    type: string;
    parsedContentBody: string;
    errorPage: boolean;
    urlRedirect: {
        destination: string;
    } | null;
    pageName: string;
}
export const DefaultAuthor: Author = {
    active: true,
    authorHash: '',
    connectWithMeText: '',
    credential: '',
    hash: '',
    userId: 0,
    username: 'Fairygodboss',
    image: {
        src: '/v1/production/tip/9/owner.webp',
        alt: 'Profile Picture',
    },
    authorImage: {
        src: '/v1/production/tip/9/owner.webp',
        alt: 'Profile Picture',
    },
    authorName: 'Fairygodboss',
};
